import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _dcc26d90 = () => interopDefault(import('../pages/application-stored.vue' /* webpackChunkName: "pages/application-stored" */))
const _79c804b0 = () => interopDefault(import('../pages/autolaina.vue' /* webpackChunkName: "pages/autolaina" */))
const _5593b7a6 = () => interopDefault(import('../pages/autorahoitus.vue' /* webpackChunkName: "pages/autorahoitus" */))
const _5bec4dee = () => interopDefault(import('../pages/cc-new/index.vue' /* webpackChunkName: "pages/cc-new/index" */))
const _081a9338 = () => interopDefault(import('../pages/cc-new/index/kuluttaja.vue' /* webpackChunkName: "pages/cc-new/index/kuluttaja" */))
const _121bb50f = () => interopDefault(import('../pages/cc-new/index/yritys.vue' /* webpackChunkName: "pages/cc-new/index/yritys" */))
const _742e2e10 = () => interopDefault(import('../pages/etutuoterahoitus.vue' /* webpackChunkName: "pages/etutuoterahoitus" */))
const _b1dd9050 = () => interopDefault(import('../pages/identiteettivakuutus.vue' /* webpackChunkName: "pages/identiteettivakuutus" */))
const _02e79b1c = () => interopDefault(import('../pages/iframe.vue' /* webpackChunkName: "pages/iframe" */))
const _65b25170 = () => interopDefault(import('../pages/iframe/leadgroup.vue' /* webpackChunkName: "pages/iframe/leadgroup" */))
const _fb140490 = () => interopDefault(import('../pages/iframe-yrityslaina.vue' /* webpackChunkName: "pages/iframe-yrityslaina" */))
const _4613a778 = () => interopDefault(import('../pages/iframe-yrityslaina/yrityslainaheti.vue' /* webpackChunkName: "pages/iframe-yrityslaina/yrityslainaheti" */))
const _479a6ff8 = () => interopDefault(import('../pages/jarjestelylaina.vue' /* webpackChunkName: "pages/jarjestelylaina" */))
const _9f0d9e02 = () => interopDefault(import('../pages/joustoluotto.vue' /* webpackChunkName: "pages/joustoluotto" */))
const _44c0391c = () => interopDefault(import('../pages/kilpailuta-lainat.vue' /* webpackChunkName: "pages/kilpailuta-lainat" */))
const _56dadcde = () => interopDefault(import('../pages/kokemuksia.vue' /* webpackChunkName: "pages/kokemuksia" */))
const _22fca71c = () => interopDefault(import('../pages/lainaa.vue' /* webpackChunkName: "pages/lainaa" */))
const _796d5711 = () => interopDefault(import('../pages/lainaa-1000-euroa.vue' /* webpackChunkName: "pages/lainaa-1000-euroa" */))
const _a10800c6 = () => interopDefault(import('../pages/lainaa-10000-euroa.vue' /* webpackChunkName: "pages/lainaa-10000-euroa" */))
const _dd4c6d88 = () => interopDefault(import('../pages/lainaa-11000-euroa.vue' /* webpackChunkName: "pages/lainaa-11000-euroa" */))
const _18d0efb8 = () => interopDefault(import('../pages/lainaa-15000-euroa.vue' /* webpackChunkName: "pages/lainaa-15000-euroa" */))
const _095769de = () => interopDefault(import('../pages/lainaa-20000-euroa.vue' /* webpackChunkName: "pages/lainaa-20000-euroa" */))
const _72ac59f9 = () => interopDefault(import('../pages/lainaa-25000-euroa.vue' /* webpackChunkName: "pages/lainaa-25000-euroa" */))
const _6332d41f = () => interopDefault(import('../pages/lainaa-30000-euroa.vue' /* webpackChunkName: "pages/lainaa-30000-euroa" */))
const _85e38340 = () => interopDefault(import('../pages/lainaa-40000-euroa.vue' /* webpackChunkName: "pages/lainaa-40000-euroa" */))
const _00e47d8d = () => interopDefault(import('../pages/lainaa-5000-euroa.vue' /* webpackChunkName: "pages/lainaa-5000-euroa" */))
const _16e9a8a1 = () => interopDefault(import('../pages/lainaa-50000-euroa.vue' /* webpackChunkName: "pages/lainaa-50000-euroa" */))
const _70c512e2 = () => interopDefault(import('../pages/lainaa-60000-euroa.vue' /* webpackChunkName: "pages/lainaa-60000-euroa" */))
const _6abf05ba = () => interopDefault(import('../pages/lainaa-70000-euroa.vue' /* webpackChunkName: "pages/lainaa-70000-euroa" */))
const _458bf6ae = () => interopDefault(import('../pages/lainahakemus.vue' /* webpackChunkName: "pages/lainahakemus" */))
const _ff61afa8 = () => interopDefault(import('../pages/lainakumppanit.vue' /* webpackChunkName: "pages/lainakumppanit" */))
const _f45bfc3e = () => interopDefault(import('../pages/lainavertailu.vue' /* webpackChunkName: "pages/lainavertailu" */))
const _51b82621 = () => interopDefault(import('../pages/luotto.vue' /* webpackChunkName: "pages/luotto" */))
const _36cb9afe = () => interopDefault(import('../pages/markkinointikielto.vue' /* webpackChunkName: "pages/markkinointikielto" */))
const _71d27a40 = () => interopDefault(import('../pages/mmkisat.vue' /* webpackChunkName: "pages/mmkisat" */))
const _0e790e63 = () => interopDefault(import('../pages/moottoripyoralaina.vue' /* webpackChunkName: "pages/moottoripyoralaina" */))
const _c9ca0c84 = () => interopDefault(import('../pages/oma/index.vue' /* webpackChunkName: "pages/oma/index" */))
const _6cbbe7a2 = () => interopDefault(import('../pages/remonttilaina.vue' /* webpackChunkName: "pages/remonttilaina" */))
const _0a35205b = () => interopDefault(import('../pages/sijoituslaina.vue' /* webpackChunkName: "pages/sijoituslaina" */))
const _27d34c91 = () => interopDefault(import('../pages/smskielto.vue' /* webpackChunkName: "pages/smskielto" */))
const _4e8464c9 = () => interopDefault(import('../pages/talous/index.vue' /* webpackChunkName: "pages/talous/index" */))
const _06e7b60e = () => interopDefault(import('../pages/tietoja-evasteista.vue' /* webpackChunkName: "pages/tietoja-evasteista" */))
const _f19ac8ce = () => interopDefault(import('../pages/venelaina.vue' /* webpackChunkName: "pages/venelaina" */))
const _aecb14b4 = () => interopDefault(import('../pages/yhdista-lainat.vue' /* webpackChunkName: "pages/yhdista-lainat" */))
const _002182fc = () => interopDefault(import('../pages/yhdistelylaina.vue' /* webpackChunkName: "pages/yhdistelylaina" */))
const _2568b014 = () => interopDefault(import('../pages/yhteistyokumppanit/index.vue' /* webpackChunkName: "pages/yhteistyokumppanit/index" */))
const _729e9f88 = () => interopDefault(import('../pages/yleiset-ehdot.vue' /* webpackChunkName: "pages/yleiset-ehdot" */))
const _7df76b44 = () => interopDefault(import('../pages/yrityksen-rahoitus.vue' /* webpackChunkName: "pages/yrityksen-rahoitus" */))
const _d3c1b8d4 = () => interopDefault(import('../pages/yritys.vue' /* webpackChunkName: "pages/yritys" */))
const _37c127a2 = () => interopDefault(import('../pages/yrityslainaa-5000-euroa.vue' /* webpackChunkName: "pages/yrityslainaa-5000-euroa" */))
const _28dce66c = () => interopDefault(import('../pages/yrityslainakumppanit.vue' /* webpackChunkName: "pages/yrityslainakumppanit" */))
const _65954da3 = () => interopDefault(import('../pages/yrityslainat.vue' /* webpackChunkName: "pages/yrityslainat" */))
const _48f6e8d6 = () => interopDefault(import('../pages/yritysrahoitus.vue' /* webpackChunkName: "pages/yritysrahoitus" */))
const _2593f105 = () => interopDefault(import('../pages/cc-new/login.vue' /* webpackChunkName: "pages/cc-new/login" */))
const _0f16216a = () => interopDefault(import('../pages/talous/ala-hae-lainaa-mista-tahansa.vue' /* webpackChunkName: "pages/talous/ala-hae-lainaa-mista-tahansa" */))
const _97055408 = () => interopDefault(import('../pages/talous/auton-hankinnassa-voi-saastaa-reilusti-kilpailuttamalla.vue' /* webpackChunkName: "pages/talous/auton-hankinnassa-voi-saastaa-reilusti-kilpailuttamalla" */))
const _90db3c68 = () => interopDefault(import('../pages/talous/essi-ja-jere-hyodynsivat-lainojen-korkokaton.vue' /* webpackChunkName: "pages/talous/essi-ja-jere-hyodynsivat-lainojen-korkokaton" */))
const _0733bca2 = () => interopDefault(import('../pages/talous/haaveiletko-urheilureissusta.vue' /* webpackChunkName: "pages/talous/haaveiletko-urheilureissusta" */))
const _3b084e3c = () => interopDefault(import('../pages/talous/hakeako-yrityslaina-perinteisesti-pankista-vai-nopeasti-ilman-vakuuksia.vue' /* webpackChunkName: "pages/talous/hakeako-yrityslaina-perinteisesti-pankista-vai-nopeasti-ilman-vakuuksia" */))
const _aed1f2ca = () => interopDefault(import('../pages/talous/kansainvaliset-digipankit-ovat-myllyttaneet-suomen-lainamarkkinat.vue' /* webpackChunkName: "pages/talous/kansainvaliset-digipankit-ovat-myllyttaneet-suomen-lainamarkkinat" */))
const _1da90a80 = () => interopDefault(import('../pages/talous/katso-5-kohdan-listaus-jolla-helpotat-taloutesi-hoitoa.vue' /* webpackChunkName: "pages/talous/katso-5-kohdan-listaus-jolla-helpotat-taloutesi-hoitoa" */))
const _7fd0df45 = () => interopDefault(import('../pages/talous/korkokatto-paattyy-joulukuussa.vue' /* webpackChunkName: "pages/talous/korkokatto-paattyy-joulukuussa" */))
const _c615afa2 = () => interopDefault(import('../pages/talous/korkokatto-putosi-kymmeneen-prosenttiin.vue' /* webpackChunkName: "pages/talous/korkokatto-putosi-kymmeneen-prosenttiin" */))
const _36653016 = () => interopDefault(import('../pages/talous/korkokattoa-jatkettiin-syksyyn.vue' /* webpackChunkName: "pages/talous/korkokattoa-jatkettiin-syksyyn" */))
const _2d1b70a8 = () => interopDefault(import('../pages/talous/kulutusluottojen-korot-laskivat-korkokaton-seurauksena.vue' /* webpackChunkName: "pages/talous/kulutusluottojen-korot-laskivat-korkokaton-seurauksena" */))
const _367ef0f0 = () => interopDefault(import('../pages/talous/kulutusluottojen-korot-putosivat-selvasti.vue' /* webpackChunkName: "pages/talous/kulutusluottojen-korot-putosivat-selvasti" */))
const _aa59e4e2 = () => interopDefault(import('../pages/talous/kulutusluottojen-lakimuutos-sai-suomalaiset-liikkeelle.vue' /* webpackChunkName: "pages/talous/kulutusluottojen-lakimuutos-sai-suomalaiset-liikkeelle" */))
const _2b70fd64 = () => interopDefault(import('../pages/talous/kulutusluottojen-saannot-uusiksi-nain-hyodyt-korkokatosta.vue' /* webpackChunkName: "pages/talous/kulutusluottojen-saannot-uusiksi-nain-hyodyt-korkokatosta" */))
const _5cafc4be = () => interopDefault(import('../pages/talous/lainat-kannattaa-yhdistaa-heti.vue' /* webpackChunkName: "pages/talous/lainat-kannattaa-yhdistaa-heti" */))
const _319ffa86 = () => interopDefault(import('../pages/talous/lainojen-yhdistaminen-kannatti.vue' /* webpackChunkName: "pages/talous/lainojen-yhdistaminen-kannatti" */))
const _c5e45d20 = () => interopDefault(import('../pages/talous/mita-tekisit-200-eurolla.vue' /* webpackChunkName: "pages/talous/mita-tekisit-200-eurolla" */))
const _31944e95 = () => interopDefault(import('../pages/talous/miten-yrityslainoja-on-jarkevin-ja-helpoin-vertailla.vue' /* webpackChunkName: "pages/talous/miten-yrityslainoja-on-jarkevin-ja-helpoin-vertailla" */))
const _8c9a4da6 = () => interopDefault(import('../pages/talous/nain-loydat-luotettavan-lainan-edullisella-korolla.vue' /* webpackChunkName: "pages/talous/nain-loydat-luotettavan-lainan-edullisella-korolla" */))
const _67509041 = () => interopDefault(import('../pages/talous/nain-selviat-kasvun-haasteista-ja-yllattavista-tilanteista.vue' /* webpackChunkName: "pages/talous/nain-selviat-kasvun-haasteista-ja-yllattavista-tilanteista" */))
const _cff34cae = () => interopDefault(import('../pages/talous/oletko-jo-kokeillut-lainojen-kilpailuttamista-verkossa.vue' /* webpackChunkName: "pages/talous/oletko-jo-kokeillut-lainojen-kilpailuttamista-verkossa" */))
const _35699788 = () => interopDefault(import('../pages/talous/petri-yhdisti-pienet-lainansa-ja-hammastyi.vue' /* webpackChunkName: "pages/talous/petri-yhdisti-pienet-lainansa-ja-hammastyi" */))
const _61c51f8c = () => interopDefault(import('../pages/talous/piia-saastaa-yli-300-euroa-kuukaudessa-laskeneen-korkokaton-ansiosta.vue' /* webpackChunkName: "pages/talous/piia-saastaa-yli-300-euroa-kuukaudessa-laskeneen-korkokaton-ansiosta" */))
const _3296476d = () => interopDefault(import('../pages/talous/pitkaan-odotettu-reissu-edessa-ja-rahat-vahissa.vue' /* webpackChunkName: "pages/talous/pitkaan-odotettu-reissu-edessa-ja-rahat-vahissa" */))
const _907c2ed4 = () => interopDefault(import('../pages/talous/teija-yhdisti-lainansa-ja-saastaa-nyt-kuluissa.vue' /* webpackChunkName: "pages/talous/teija-yhdisti-lainansa-ja-saastaa-nyt-kuluissa" */))
const _10ded314 = () => interopDefault(import('../pages/talous/vakuudettomien-lainojen-korkoja-rajoittava-laki-astui-voimaan.vue' /* webpackChunkName: "pages/talous/vakuudettomien-lainojen-korkoja-rajoittava-laki-astui-voimaan" */))
const _0304c5ca = () => interopDefault(import('../pages/yhteistyokumppanit/_company.vue' /* webpackChunkName: "pages/yhteistyokumppanit/_company" */))
const _869162ec = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/application-stored",
    component: _dcc26d90,
    name: "application-stored"
  }, {
    path: "/autolaina",
    component: _79c804b0,
    name: "autolaina"
  }, {
    path: "/autorahoitus",
    component: _5593b7a6,
    name: "autorahoitus"
  }, {
    path: "/cc-new",
    component: _5bec4dee,
    name: "cc-new",
    children: [{
      path: "kuluttaja",
      component: _081a9338,
      name: "cc-new-index-kuluttaja"
    }, {
      path: "yritys",
      component: _121bb50f,
      name: "cc-new-index-yritys"
    }]
  }, {
    path: "/etutuoterahoitus",
    component: _742e2e10,
    name: "etutuoterahoitus"
  }, {
    path: "/identiteettivakuutus",
    component: _b1dd9050,
    name: "identiteettivakuutus"
  }, {
    path: "/iframe",
    component: _02e79b1c,
    name: "iframe",
    children: [{
      path: "leadgroup",
      component: _65b25170,
      name: "iframe-leadgroup"
    }]
  }, {
    path: "/iframe-yrityslaina",
    component: _fb140490,
    name: "iframe-yrityslaina",
    children: [{
      path: "yrityslainaheti",
      component: _4613a778,
      name: "iframe-yrityslaina-yrityslainaheti"
    }]
  }, {
    path: "/jarjestelylaina",
    component: _479a6ff8,
    name: "jarjestelylaina"
  }, {
    path: "/joustoluotto",
    component: _9f0d9e02,
    name: "joustoluotto"
  }, {
    path: "/kilpailuta-lainat",
    component: _44c0391c,
    name: "kilpailuta-lainat"
  }, {
    path: "/kokemuksia",
    component: _56dadcde,
    name: "kokemuksia"
  }, {
    path: "/lainaa",
    component: _22fca71c,
    name: "lainaa"
  }, {
    path: "/lainaa-1000-euroa",
    component: _796d5711,
    name: "lainaa-1000-euroa"
  }, {
    path: "/lainaa-10000-euroa",
    component: _a10800c6,
    name: "lainaa-10000-euroa"
  }, {
    path: "/lainaa-11000-euroa",
    component: _dd4c6d88,
    name: "lainaa-11000-euroa"
  }, {
    path: "/lainaa-15000-euroa",
    component: _18d0efb8,
    name: "lainaa-15000-euroa"
  }, {
    path: "/lainaa-20000-euroa",
    component: _095769de,
    name: "lainaa-20000-euroa"
  }, {
    path: "/lainaa-25000-euroa",
    component: _72ac59f9,
    name: "lainaa-25000-euroa"
  }, {
    path: "/lainaa-30000-euroa",
    component: _6332d41f,
    name: "lainaa-30000-euroa"
  }, {
    path: "/lainaa-40000-euroa",
    component: _85e38340,
    name: "lainaa-40000-euroa"
  }, {
    path: "/lainaa-5000-euroa",
    component: _00e47d8d,
    name: "lainaa-5000-euroa"
  }, {
    path: "/lainaa-50000-euroa",
    component: _16e9a8a1,
    name: "lainaa-50000-euroa"
  }, {
    path: "/lainaa-60000-euroa",
    component: _70c512e2,
    name: "lainaa-60000-euroa"
  }, {
    path: "/lainaa-70000-euroa",
    component: _6abf05ba,
    name: "lainaa-70000-euroa"
  }, {
    path: "/lainahakemus",
    component: _458bf6ae,
    name: "lainahakemus"
  }, {
    path: "/lainakumppanit",
    component: _ff61afa8,
    name: "lainakumppanit"
  }, {
    path: "/lainavertailu",
    component: _f45bfc3e,
    name: "lainavertailu"
  }, {
    path: "/luotto",
    component: _51b82621,
    name: "luotto"
  }, {
    path: "/markkinointikielto",
    component: _36cb9afe,
    name: "markkinointikielto"
  }, {
    path: "/mmkisat",
    component: _71d27a40,
    name: "mmkisat"
  }, {
    path: "/moottoripyoralaina",
    component: _0e790e63,
    name: "moottoripyoralaina"
  }, {
    path: "/oma",
    component: _c9ca0c84,
    name: "oma"
  }, {
    path: "/remonttilaina",
    component: _6cbbe7a2,
    name: "remonttilaina"
  }, {
    path: "/sijoituslaina",
    component: _0a35205b,
    name: "sijoituslaina"
  }, {
    path: "/smskielto",
    component: _27d34c91,
    name: "smskielto"
  }, {
    path: "/talous",
    component: _4e8464c9,
    name: "talous"
  }, {
    path: "/tietoja-evasteista",
    component: _06e7b60e,
    name: "tietoja-evasteista"
  }, {
    path: "/venelaina",
    component: _f19ac8ce,
    name: "venelaina"
  }, {
    path: "/yhdista-lainat",
    component: _aecb14b4,
    name: "yhdista-lainat"
  }, {
    path: "/yhdistelylaina",
    component: _002182fc,
    name: "yhdistelylaina"
  }, {
    path: "/yhteistyokumppanit",
    component: _2568b014,
    name: "yhteistyokumppanit"
  }, {
    path: "/yleiset-ehdot",
    component: _729e9f88,
    name: "yleiset-ehdot"
  }, {
    path: "/yrityksen-rahoitus",
    component: _7df76b44,
    name: "yrityksen-rahoitus"
  }, {
    path: "/yritys",
    component: _d3c1b8d4,
    name: "yritys"
  }, {
    path: "/yrityslainaa-5000-euroa",
    component: _37c127a2,
    name: "yrityslainaa-5000-euroa"
  }, {
    path: "/yrityslainakumppanit",
    component: _28dce66c,
    name: "yrityslainakumppanit"
  }, {
    path: "/yrityslainat",
    component: _65954da3,
    name: "yrityslainat"
  }, {
    path: "/yritysrahoitus",
    component: _48f6e8d6,
    name: "yritysrahoitus"
  }, {
    path: "/cc-new/login",
    component: _2593f105,
    name: "cc-new-login"
  }, {
    path: "/talous/ala-hae-lainaa-mista-tahansa",
    component: _0f16216a,
    name: "talous-ala-hae-lainaa-mista-tahansa"
  }, {
    path: "/talous/auton-hankinnassa-voi-saastaa-reilusti-kilpailuttamalla",
    component: _97055408,
    name: "talous-auton-hankinnassa-voi-saastaa-reilusti-kilpailuttamalla"
  }, {
    path: "/talous/essi-ja-jere-hyodynsivat-lainojen-korkokaton",
    component: _90db3c68,
    name: "talous-essi-ja-jere-hyodynsivat-lainojen-korkokaton"
  }, {
    path: "/talous/haaveiletko-urheilureissusta",
    component: _0733bca2,
    name: "talous-haaveiletko-urheilureissusta"
  }, {
    path: "/talous/hakeako-yrityslaina-perinteisesti-pankista-vai-nopeasti-ilman-vakuuksia",
    component: _3b084e3c,
    name: "talous-hakeako-yrityslaina-perinteisesti-pankista-vai-nopeasti-ilman-vakuuksia"
  }, {
    path: "/talous/kansainvaliset-digipankit-ovat-myllyttaneet-suomen-lainamarkkinat",
    component: _aed1f2ca,
    name: "talous-kansainvaliset-digipankit-ovat-myllyttaneet-suomen-lainamarkkinat"
  }, {
    path: "/talous/katso-5-kohdan-listaus-jolla-helpotat-taloutesi-hoitoa",
    component: _1da90a80,
    name: "talous-katso-5-kohdan-listaus-jolla-helpotat-taloutesi-hoitoa"
  }, {
    path: "/talous/korkokatto-paattyy-joulukuussa",
    component: _7fd0df45,
    name: "talous-korkokatto-paattyy-joulukuussa"
  }, {
    path: "/talous/korkokatto-putosi-kymmeneen-prosenttiin",
    component: _c615afa2,
    name: "talous-korkokatto-putosi-kymmeneen-prosenttiin"
  }, {
    path: "/talous/korkokattoa-jatkettiin-syksyyn",
    component: _36653016,
    name: "talous-korkokattoa-jatkettiin-syksyyn"
  }, {
    path: "/talous/kulutusluottojen-korot-laskivat-korkokaton-seurauksena",
    component: _2d1b70a8,
    name: "talous-kulutusluottojen-korot-laskivat-korkokaton-seurauksena"
  }, {
    path: "/talous/kulutusluottojen-korot-putosivat-selvasti",
    component: _367ef0f0,
    name: "talous-kulutusluottojen-korot-putosivat-selvasti"
  }, {
    path: "/talous/kulutusluottojen-lakimuutos-sai-suomalaiset-liikkeelle",
    component: _aa59e4e2,
    name: "talous-kulutusluottojen-lakimuutos-sai-suomalaiset-liikkeelle"
  }, {
    path: "/talous/kulutusluottojen-saannot-uusiksi-nain-hyodyt-korkokatosta",
    component: _2b70fd64,
    name: "talous-kulutusluottojen-saannot-uusiksi-nain-hyodyt-korkokatosta"
  }, {
    path: "/talous/lainat-kannattaa-yhdistaa-heti",
    component: _5cafc4be,
    name: "talous-lainat-kannattaa-yhdistaa-heti"
  }, {
    path: "/talous/lainojen-yhdistaminen-kannatti",
    component: _319ffa86,
    name: "talous-lainojen-yhdistaminen-kannatti"
  }, {
    path: "/talous/mita-tekisit-200-eurolla",
    component: _c5e45d20,
    name: "talous-mita-tekisit-200-eurolla"
  }, {
    path: "/talous/miten-yrityslainoja-on-jarkevin-ja-helpoin-vertailla",
    component: _31944e95,
    name: "talous-miten-yrityslainoja-on-jarkevin-ja-helpoin-vertailla"
  }, {
    path: "/talous/nain-loydat-luotettavan-lainan-edullisella-korolla",
    component: _8c9a4da6,
    name: "talous-nain-loydat-luotettavan-lainan-edullisella-korolla"
  }, {
    path: "/talous/nain-selviat-kasvun-haasteista-ja-yllattavista-tilanteista",
    component: _67509041,
    name: "talous-nain-selviat-kasvun-haasteista-ja-yllattavista-tilanteista"
  }, {
    path: "/talous/oletko-jo-kokeillut-lainojen-kilpailuttamista-verkossa",
    component: _cff34cae,
    name: "talous-oletko-jo-kokeillut-lainojen-kilpailuttamista-verkossa"
  }, {
    path: "/talous/petri-yhdisti-pienet-lainansa-ja-hammastyi",
    component: _35699788,
    name: "talous-petri-yhdisti-pienet-lainansa-ja-hammastyi"
  }, {
    path: "/talous/piia-saastaa-yli-300-euroa-kuukaudessa-laskeneen-korkokaton-ansiosta",
    component: _61c51f8c,
    name: "talous-piia-saastaa-yli-300-euroa-kuukaudessa-laskeneen-korkokaton-ansiosta"
  }, {
    path: "/talous/pitkaan-odotettu-reissu-edessa-ja-rahat-vahissa",
    component: _3296476d,
    name: "talous-pitkaan-odotettu-reissu-edessa-ja-rahat-vahissa"
  }, {
    path: "/talous/teija-yhdisti-lainansa-ja-saastaa-nyt-kuluissa",
    component: _907c2ed4,
    name: "talous-teija-yhdisti-lainansa-ja-saastaa-nyt-kuluissa"
  }, {
    path: "/talous/vakuudettomien-lainojen-korkoja-rajoittava-laki-astui-voimaan",
    component: _10ded314,
    name: "talous-vakuudettomien-lainojen-korkoja-rajoittava-laki-astui-voimaan"
  }, {
    path: "/yhteistyokumppanit/:company",
    component: _0304c5ca,
    name: "yhteistyokumppanit-company"
  }, {
    path: "/",
    component: _869162ec,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
